import ItemStatus, {ItemStatusProps} from './ItemStatus'

export enum NavigationStatus {
  INITIAL_STATE = 'INITIAL_STATE',
  PARTIALLY_FILLED = 'PARTIALLY_FILLED',
  FILLED = 'FILLED',
  APPROVED = 'APPROVED',
}

export type {ItemStatusProps}

export default ItemStatus
